export default {
  有效交易量达标即可获得:'*有效交易量达标即可获得奖励，详见<a href="#pay-session5">活动须知</a> ',
  交易领薪计划: "基金经理成长计划",
  为了鼓励交易者提升交易水平:`用交易能力赢取 <span class="red">18<span class="sRed">%</span></span> 年化管理费`,
  加入交易社区: "根据交易员的管理资金量发放月度奖金，奖金比例高达年化18%！",
  即刻发起交易信号: "即刻发起交易信号",
  无限奖励月月拿: "无限奖励月月拿",
  优享11个专属大礼: "优享10个专属大礼",
  即刻加入: "即刻加入",
  交易员等级奖励机制: `交易员等级奖励机制`,
  EBC基于跟随人数和资金提供五档奖励:
    "EBC基于跟随用户数和管理资金量提供五档奖励。",
  "/月": "/月",
  精英交易员: "精英交易员",
  管理资金量: "管理资金量",
  跟随账户数: "跟随用户数",
  大师交易员: "大师交易员",
  冠军交易员: "冠军交易员",
  明星交易员: "明星交易员",
  资金管理费: "+1%资金管理费",
  传奇交易员: "传奇交易员",
  多层次的增值服务: "多层次的增值服务",
  EBC提供多达11项增值服务:
    "EBC提供多达11项增值服务，整合流量和媒体资源，全面提升信号影响力。",
  "精英/大师交易员": "精英/大师交易员",

  "7×24小时优先客服": "7×24小时优先客服",
  金融投资经典书籍礼遇: "金融投资经典书籍礼遇",
  专属VPS赞助: "专属VPS赞助",
  订单流软件1年使用权: "订单流软件1年使用权",
  EBC定制大礼包: "EBC定制大礼包",
  信号优先置顶展示: "信号优先置顶展示",
  受邀参观海外办公室: "受邀参观海外办公室",
  巴萨球星联名礼包: "巴萨球星联名礼包",
  巴萨赛场传奇之旅: "巴萨赛场传奇之旅",
  品牌战略合作: "品牌战略合作",
  全球金融资源管家服务: "全球金融资源管家服务",
  五维指标评价系统: "五维指标评价系统",
  为交易员信号提供公开透明的评估:
    "为交易员信号提供公开透明的评估，展示交易风格，提升曝光率，从而吸引更多跟随者。",
  收益率: "收益率",
  历史收益率: "历史收益率，值越高越好。",
  最大回撤: "最大回撤",
  衡量风控能力: "衡量风控能力，越低风险越小。",
  获利系数: "获利系数",
  利润因子: "利润因子，越高盈利能力越强",
  夏普比率: "夏普比率",
  每份风险的收益: "每份风险的收益，越高性价比越高。",
  标准差: "标准差",
  收益波动率: "收益波动率，越低越稳定。",
  以上数据仅供参考: "*以上数据仅供参考。",
  活动须知: "活动须知",
  list: [
    {
      label: "1.跟单信息定义",
      value: [
        {label:'跟随资金量：单个账号的跟随资金量 = 该账号余额 ÷ 跟随信号数。',value:[]},
        {label:'跟随限制：每个账号最多可同时跟随10个信号。',value:[]},
        {label:'有效跟随账号：跟随资金量≥500美元计为有效跟随账号；不足500美元不计入有效跟随账号，也不计入跟随资金量。​​',value:[]},
        {label:'有效跟随用户：同一EBC账户下，多个有效账号同时跟随同一交易员(交易信号)，仅计为1个有效用户。',value:[]},
        {label:'管理资金量：全部跟随资金量 + 交易员(交易信号)账号余额。',value:[]},
        // {label:'数据排除：交易员名下账号跟随自己的信号，不计入有效跟随用户和跟随资金量。',value:[]}
      ],
    },
    {
      label: "2.等级激活和奖励规则",
      value: [
        {label:'等级激活:',value:[{innerLabel:'系统每小时自动评估，若管理资金量与有效用户数同时满足某一等级要求，即视为该等级激活。',innerValue:[]}]},
        {label:'奖励条件（需同时满足）：',
          value:[{innerLabel:'当月每个自然日均达到对应交易员等级。',innerValue:[]},{innerLabel:'有效交易量(手) ≥ 交易员(交易信号)日均余额 × 0.2%:',innerValue:['有效交易量=当月平仓交易量+净持仓量(扣除同品种双向持仓后的净头寸)。','交易员(交易信号)日均余额=当月交易员(交易信号)每日余额总和÷当月自然日天数。', '美股和ETF不计入有效交易量统计。']},
      
          ]},
        {label:'奖金计算和发放：',value:[{innerLabel:'日均管理资金量=当月每日管理资金量总和÷当月自然日天数。',innerValue:[]},{innerLabel:'月度奖金=（日均管理资金量×资金管理费率）÷12。',innerValue:[]},{innerLabel:'次月第一周核算上月奖励，审核通过后发放至交易账号。',innerValue:[]},{innerLabel:'本活动限真实有效客户参与，活动规则及有效客户定义的最终解释权归EBC所有。',innerValue:[]}
         ]}
      ],
    }
  ],
  年化资金管理费: "年化资金管理费",
};
